import {useState, useCallback} from "react"
import {useCropper} from "../../hooks/useCropper"

export const useVideoControls = (materialIndex: number) => {
    const cropper = useCropper(materialIndex)
    const [isMuted, setIsMuted] = useState(false)

    const isVideoPlaying = cropper?.imageState.videoPlaying || false

    const toggleVideoPlaying = useCallback(() => {
        if (!cropper) return
        cropper.setImageState({
            videoPlaying: !isVideoPlaying,
        })
    }, [cropper, isVideoPlaying])

    const toggleMute = useCallback(() => {
        const videoElement = document.getElementById(
            `video${materialIndex}`
        ) as HTMLVideoElement
        if (videoElement) {
            videoElement.muted = !isMuted
            setIsMuted(!isMuted)
        }
    }, [materialIndex, isMuted])

    const isVideoDisabled = useCallback(
        (imageState: any) =>
            imageState?.status === "loaded" &&
            imageState?.videoUrl &&
            isVideoPlaying,
        [isVideoPlaying]
    )

    return {
        isVideoPlaying,
        isMuted,
        toggleVideoPlaying,
        toggleMute,
        isVideoDisabled,
    }
}
